exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-5e67b9fa]{margin:0 0 40px -5px}.login[data-v-5e67b9fa]{margin-top:100px}.login .signup-box[data-v-5e67b9fa]{font-family:Roboto,sans-serif;margin-top:30px;padding:0 30px 30px;border:2px solid #017bff;border-radius:5px}.login .signup-box h4[data-v-5e67b9fa]{margin:20px 0;font-size:20px}.login .login-box[data-v-5e67b9fa]{font-family:Roboto,sans-serif;padding:30px;border:2px solid transparent;border-radius:5px}.login .login-box .error[data-v-5e67b9fa]{padding:10px 20px;border:2px solid #ff0203;color:#fff;border-radius:5px;margin-top:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5e67b9fa","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/login.vue
// module id = 400
// module chunks = 0